import { render, staticRenderFns } from "./GeneralManager.vue?vue&type=template&id=05a9bf3b&scoped=true"
import script from "./GeneralManager.vue?vue&type=script&lang=js"
export * from "./GeneralManager.vue?vue&type=script&lang=js"
import style0 from "./GeneralManager.vue?vue&type=style&index=0&id=05a9bf3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9bf3b",
  null
  
)

export default component.exports